import { render } from "./floatingone.html?vue&type=template&id=fa36fe44&external"
import script from "./floatingone.js?vue&type=script&lang=js&external"
export * from "./floatingone.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__